// <artwork-countdown data-deadline="ISO8601"> — self-contained countdown.
// Renders days/hours/minutes/seconds until the deadline. When the deadline
// passes it adds the `is-expired` class and reloads the page once so the
// server re-evaluates the artwork's availability state.
class ArtworkCountdown extends HTMLElement {
  connectedCallback() {
    const raw = this.getAttribute('data-deadline');
    this.deadline = raw ? new Date(raw).getTime() : NaN;
    if (Number.isNaN(this.deadline)) return;

    this.parts = {
      days: this.querySelector('[data-unit="days"]'),
      hours: this.querySelector('[data-unit="hours"]'),
      minutes: this.querySelector('[data-unit="minutes"]'),
      seconds: this.querySelector('[data-unit="seconds"]'),
    };

    this.tick();
    this.timer = window.setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    if (this.timer) window.clearInterval(this.timer);
  }

  tick() {
    const diff = this.deadline - Date.now();

    if (diff <= 0) {
      window.clearInterval(this.timer);
      this.classList.add('is-expired');
      if (!this.hasAttribute('data-no-reload')) {
        // Reload once so Liquid re-renders the correct state (buyable / sold out).
        window.location.reload();
      }
      return;
    }

    const seconds = Math.floor(diff / 1000);
    const set = (el, value) => {
      if (el) el.textContent = String(value).padStart(2, '0');
    };

    set(this.parts.days, Math.floor(seconds / 86400));
    set(this.parts.hours, Math.floor((seconds % 86400) / 3600));
    set(this.parts.minutes, Math.floor((seconds % 3600) / 60));
    set(this.parts.seconds, seconds % 60);
  }
}

if (!customElements.get('artwork-countdown')) {
  customElements.define('artwork-countdown', ArtworkCountdown);
}
